<template>
    <div class="ToolkitAndEnrollmentsFilterBar">
        <div class="container-fluid">
            <div class="row vertical-align margin-Top-2Perc margin-bottom-2Perc">
                <div class="col-md-2 col-lg-2 text-align-right padding-left-1Point5Perc">
                    Group Course(s)
                </div>    
                <div class="col-md-4 col-lg-4">
                    <div class="form-group">
                        <div class="col-sm-12 padding-left-right-0Px">
                            <select class="form-control" v-model="selectedGroupObj">
                              <option value=-1 disabled>Select</option>
                              <option v-for="groupCourseObj in getGroupCourseList" v-bind:key="groupCourseObj.GroupCourseMasterId" v-bind:value="groupCourseObj">{{ groupCourseObj.GroupName }} :: {{groupCourseObj.CourseTitle}} {{groupCourseObj.CourseSubTitle !== null && groupCourseObj.CourseSubTitle.trim().length !== 0 ? '[' + groupCourseObj.CourseSubTitle + ']': ''}}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="col-md-1 col-lg-1 text-align-right">
                    Cohort(s)
                </div>    
                <div class="col-md-3 col-lg-3">
                    <div class="form-group">
                        <div class="col-sm-12 padding-left-right-0Px">
                            <select class="form-control" v-model="selectedCohortObj">
                            <option value='-1' disabled>Select</option>
                            <option v-for="cohortObj in getAssociatedCohorts" v-bind:key="cohortObj.CohortId" v-bind:value="cohortObj">{{ cohortObj.CohortName }}</option>
                          </select> 
                        </div>
                    </div>
                </div>
                <div class="col-md-1 col-lg-1">
                  <button class="btn btn-primary btn-block unenroll-existing-button-BG black-font-color padding-left-right-0Px" v-on:click="viewParticipants($event)">View</button>
                </div>
                <div class="col-md-1 col-lg-1">
                </div>
            </div>
            <div class="row vertical-align margin-Top-2Perc margin-bottom-2Perc">
              <div class="col-md-1 col-lg-1">
                </div>
                <div class="col-md-2 col-lg-2">
                  <button class="btn btn-primary btn-block unenroll-existing-button-BG black-font-color padding-left-right-0Px" @click="askUserConfirmation($event, true, 'participant', true)" :disabled="!showUnEnrollParticipantList">Enroll Participants</button>
                </div>
                <div class="col-md-2 col-lg-2">
                  <button class="btn btn-primary btn-block unenroll-existing-button-BG black-font-color padding-left-right-1Point5Px" @click="askUserConfirmation($event, true, 'course', true)" :disabled="!showUnEnrollParticipantList">Allow Course</button>
                </div> 
                <div class="col-md-2 col-lg-2">
                    <button class="btn btn-primary btn-block unenroll-existing-button-BG black-font-color padding-left-right-1Point5Px" @click="askUserConfirmation($event, true, 'toolkit', true)" :disabled="!showUnEnrollParticipantList">Allow Toolkit</button>
                </div>  
                <div class="col-md-2 col-lg-2">
                  <button class="btn btn-primary btn-block unenroll-existing-button-BG black-font-color padding-left-right-1Point5Px" @click="askUserConfirmation($event, true, 'certificate', true)" :disabled="!showUnEnrollParticipantList">Allow Certificate</button>
                </div>
                <div class="col-md-2 col-lg-2">
                  <button class="btn btn-primary btn-block unenroll-existing-button-BG black-font-color padding-left-right-1Point5Px" @click="askUserConfirmation($event, true, 'generate_certificate_for_selected', true)" :disabled="!showUnEnrollParticipantList || !isGroupCourseCertificatePresent()">Generate Certificate</button>
                </div>
                <div class="col-md-1 col-lg-1">
                </div>
            </div>
            <div class="row vertical-align margin-Top-2Perc margin-bottom-2Perc">
              <div class="col-md-1 col-lg-1">
                </div>
                <div class="col-md-2 col-lg-2">
                  <button class="btn btn-primary btn-block unenroll-existing-button-BG black-font-color padding-left-right-0Px" @click="askUserConfirmation($event, true, 'participant', false)" :disabled="!showUnEnrollParticipantList">Un-enroll Participants</button>
                </div>
                <div class="col-md-2 col-lg-2">
                  <button class="btn btn-primary btn-block unenroll-existing-button-BG black-font-color padding-left-right-1Point5Px" @click="askUserConfirmation($event, true, 'course', false)" :disabled="!showUnEnrollParticipantList">Disallow Course</button>
                </div> 
                <div class="col-md-2 col-lg-2">
                    <button class="btn btn-primary btn-block unenroll-existing-button-BG black-font-color padding-left-right-1Point5Px" @click="askUserConfirmation($event, true, 'toolkit', false)" :disabled="!showUnEnrollParticipantList">Remove Toolkit</button>
                </div>  
                <div class="col-md-2 col-lg-2">
                   <button class="btn btn-primary btn-block unenroll-existing-button-BG black-font-color padding-left-right-1Point5Px" @click="askUserConfirmation($event, true, 'certificate', false)" :disabled="!showUnEnrollParticipantList">Disallow Certificate</button> 
                </div>
                <div class="col-md-2 col-lg-2">
                </div>
                <div class="col-md-1 col-lg-1">
                </div>
            </div>
            <hr width="100%">
            <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="null" v-bind:prefixString="prefixWarningString" v-bind:postfixString="postWarningString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="performOperation"></confirmation-alert>
            <un-enroll-participant-list v-if="showUnEnrollParticipantList" :selectedCohortObj="getSelectedCohortObj" :userObjList="UserObjList" v-bind:selectedGCMObj="getSelectedGroupCourseObj" @refreshList="refreshEnrolledParticipantList" @userList="updateUserIdListToProccessList" @sortBasedOnColumnName="updateSortDetails"></un-enroll-participant-list>
            <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
            <!-- Show Spinner -->
            <div class="animationload" v-show="showSpinner">
              <div class="osahanloading"></div>
            </div>
            <loader></loader>      
            <proccessed-certificate-response v-if="showBatchGenerationCertificateRespOverlay" :respArr="regeneratesUserCertificateIdsResp" :totalCertificateToGenerate="totalBatchCertificateGenerationCount" @showOverlay="closeOverlay"></proccessed-certificate-response>
        </div>
    </div>    
</template>

<script>

import Loader from '@/components/dashboard/Loader'
import { constants } from '@/utils/constants'
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
import { groupCourseService } from '@/server-util/group-course-service'
import ProccessedCertificateResponse from '@/components/ProccessedCertificateResponse'
import UnEnrollParticipantList from '@/components/UnEnrollParticipantList'
import { cohortService } from '@/server-util/cohort-service'
import { participantService } from '@/server-util/participant-service'
import AlertBox from '@/components/AlertOverlay'
import orderBy from 'lodash/orderBy'
import forEach from 'lodash/forEach'
import find from 'lodash/find'
import filter from 'lodash/filter'
export default {
  props: ['resetFilter'],
  created: function () {
    this.getAllGroupCourses()
  },
  data: function () {
    return {
      showAlertDialog: false,
      errorMsg: '',
      showSpinner: false,
      selectedGroupObj: -1,
      selectedCohortObj: -1,
      showUnEnrollParticipantList: false,
      associatedCohortList: [],
      UserObjList: [],
      showConfirmationBox: false,
      prefixWarningString: 'Are you sure you want to delete ',
      postWarningString: '?',
      selectedOperationType: 'toolkit',
      isAllowed: false,
      userIdListToProccess: [],
      sortOrder: 'asc',
      sortBy: 'UserProgress',
      regenerateUserCertificateIds: [],
      totalBatchCertificateGenerationCount: 0,
      regeneratesUserCertificateIdsResp: [],
      showBatchGenerationCertificateRespOverlay: false
    }
  },
  methods: {
    closeOverlay (value) {
      this.showBatchGenerationCertificateRespOverlay = value
    },
    isGroupCourseCertificatePresent: function () {
      if (this.getSelectedGroupCourseObj.Certificate !== undefined && this.getSelectedGroupCourseObj.Certificate !== 'undefined' && this.getSelectedGroupCourseObj.Certificate !== null && this.getSelectedGroupCourseObj.Certificate !== 'null' && this.getSelectedGroupCourseObj.Certificate !== '') {
        if (this.getSelectedGroupCourseObj.Certificate.CertificateFile !== undefined && this.getSelectedGroupCourseObj.Certificate.CertificateFile !== 'undefined' && this.getSelectedGroupCourseObj.Certificate.CertificateFile !== null && this.getSelectedGroupCourseObj.Certificate.CertificateFile !== 'null' && this.getSelectedGroupCourseObj.Certificate.CertificateFile !== '') {
          if (!this.getSelectedGroupCourseObj.DisableCertification) {
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      } else {
        return false
      }
    },
    updateSortDetails (value) {
      this.sortOrder = value.SortType
      this.sortBy = value.ColumnName
      this.sortUserList()
    },
    sortUserList: function () {
      this.UserObjList = orderBy(this.UserObjList, this.sortBy, this.sortOrder)
    },
    updateUserIdListToProccessList (value) {
      this.userIdListToProccess = value
      console.log('this.userIdListToProccess.length: ' + JSON.stringify(this.userIdListToProccess))
    },
    viewParticipants: function (event) {
      if (this.selectedGroupObj !== -1) {
        if (this.selectedCohortObj !== -1) {
          // AK: Issue call to get List of Participant(s)
          this.getParticipantListUsingCohort(true)
        } else {
          this.showAlertDialog = true
          this.errorMsg =
            'Please select a cohort to view participant list.'
        }
      } else {
        this.showAlertDialog = true
        this.errorMsg =
          'Please select a group course to view participant list.'
      }
    },
    getParticipantListUsingCohort: function (showSpinner = true) {
      var storeObj = this.$store
      var _this = this
      if (
        this.selectedCohortObj !== -1
      ) {
        if (showSpinner) {
          _this.$store.state.isLoading = true
        }
        participantService
          .getParticipantListUsingCohortId(
            storeObj.state.access_token,
            this.selectedCohortObj.CohortId
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Hide Spinner after recieving Participant list response
              _this.$store.state.isLoading = false
              if (responseObj.data.length === 0) {
                // AK: Hide participant List UI
                this.showUnEnrollParticipantList = false
                this.showAlertDialog = true
                this.errorMsg = 'No participant found in \'' + this.selectedCohortObj.CohortName + '\'.'
              } else {
                this.UserObjList = responseObj.data
                this.sortUserList()
                // AK: Show participant List to user
                this.showUnEnrollParticipantList = true
              }
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              // AK: Hide Spinner if error occured
              _this.$store.state.isLoading = false
            }
          }, errorObj => {
            // AK: Hide Spinner if error occured
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Select Cohort ID is NULL hence declined LISTING Associated Participant(s) OPERATION'
        )
      }
    },
    refreshEnrolledParticipantList (value) {
      // AK: used to refresh Participant list when user performed enroll/unenrollment and allow/remove toolkit
      if (value) {
        this.getParticipantListUsingCohort(true)
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    getAssociatedCohortList: function () {
      var storeObj = this.$store
      var _this = this
      if (
        this.selectedGroupObj !== -1
      ) {
        // _this.showSpinner = true
        _this.$store.state.isLoading = true
        cohortService
          .getCohortListUsingGroupCourse(
            storeObj.state.access_token,
            this.selectedGroupObj.GroupCourseMasterId
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Hide Spinner after recieving Cohort list response
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              if (responseObj.data.length === 0) {
                this.showAlertDialog = true
                var subTitleName = this.selectedGroupObj.CourseSubTitle === null ? '' : ' [' + this.selectedGroupObj.CourseSubTitle + ']'
                this.errorMsg = 'No cohort found in \'' + this.selectedGroupObj.GroupName + ' :: ' + this.selectedGroupObj.CourseTitle + subTitleName + '\'.'
              }
              this.associatedCohortList = responseObj.data
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              // AK: Hide Spinner if error occured
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
            }
          }, errorObj => {
            // AK: Hide Spinner if error occured
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Select Group ID is NULL hence declined LISTING Associated Cohort(s) OPERATION'
        )
      }
    },
    getAllGroupCourses: function () {
      var storeObj = this.$store
      var _this = this
      if (
        storeObj.state.access_token !== undefined || storeObj.state.access_token !== ''
      ) {
        // AK: If group courses are not available then only show spinner
        if (storeObj.state.groupCourseList.length === 0) {
          // _this.showSpinner = true
          _this.$store.state.isLoading = true
        }
        groupCourseService
          .getGroupCourseList(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              storeObj.state.groupCourseList = responseObj.data
              if (this.$store.state.isLoading === true) {
                // AK: Hide Spinner after recieving Group Course list
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
              }
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              if (_this.$store.state.isLoading === true) {
                // AK: Hide Spinner after recieving Group Course list
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
              }
            }
          }, errorObj => {
            if (_this.$store.state.isLoading === true) {
              // AK: Hide Spinner after recieving Group Course list
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
            }
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Access Token is NULL hence declined GROUP COURSE LISTING OPERATION'
        )
      }
    },
    askUserConfirmation: function ($event, flagToUpdate, selectedType = 'toolkit', isAllowed = false) {
      if (this.selectedGroupObj !== -1 && this.selectedCohortObj !== -1) {
        this.selectedOperationType = selectedType
        this.isAllowed = isAllowed
        this.prefixWarningString = 'Are you sure you want to '
        var middleString = ''
        if (this.userIdListToProccess.length > 0) {
          switch (selectedType) {
            case 'participant':
              middleString = this.isAllowed ? 'enroll' : 'un-enroll'
              this.postWarningString = middleString + ' the selected participant(s) into \'' + this.selectedCohortObj.CohortName + '\' cohort?'
              this.showConfirmationBox = true
              break
            case 'toolkit':
              middleString = this.isAllowed ? 'allow' : 'remove'
              this.postWarningString = middleString + ' the toolkit for all the selected participant(s) which are enrolled in \'' + this.selectedCohortObj.CohortName + '\' cohort?'
              this.showConfirmationBox = true
              break
            case 'course':
              middleString = this.isAllowed ? 'allow' : 'disallow'
              this.postWarningString = middleString + ' course for all the selected participant(s) which are enrolled in \'' + this.selectedCohortObj.CohortName + '\' cohort?'
              this.showConfirmationBox = true
              break
            case 'certificate':
              const resultObj = this.checkIfCertificateGeneratedForAll()
              if (resultObj.HasCertificateGeneratedForAll) {
                middleString = this.isAllowed ? 'allow' : 'disallow'
                this.postWarningString = middleString + ' certificate for all the selected participant(s) which are enrolled in \'' + this.selectedCohortObj.CohortName + '\' cohort?'
                // AK: Show confirmation dialog
                this.showConfirmationBox = true
              } else {
                this.errorMsg = 'Please uncheck \'' + resultObj.NonCertificateGenerateHolders + '\' user(s) from current selection as certificate is not yet generated for them.'
                this.showAlertDialog = true
              }
              break
            case 'generate_certificate_for_selected':
              if (this.isGroupCourseCertificatePresent()) {
                this.postWarningString = 'generate the certificate for all the selected participant(s) which are enrolled in \'' + this.selectedCohortObj.CohortName + '\' cohort?'
                // AK: Show confirmation dialog
                this.showConfirmationBox = true
              }
              break
          }
        } else {
          this.showAlertDialog = true
          this.errorMsg = 'Please select at least one participant to perform selected action.'
        }
      } else {
        if (this.selectedGroupObj === -1) {
          this.showAlertDialog = true
          this.errorMsg = 'Please select a group course.'
        } else {
          this.showAlertDialog = true
          this.errorMsg = 'Please select a cohort.'
        }
      }
    },
    isUserCertificatePresent: function (userObj) {
      // console.log('userObj:' + JSON.stringify(userObj))
      if (userObj.UserCertificate !== undefined && userObj.UserCertificate !== 'undefined' && userObj.UserCertificate !== null && userObj.UserCertificate !== 'null' && userObj.UserCertificate !== '') {
        if ((userObj.UserCertificate.CertificatePDFUrl !== undefined && userObj.UserCertificate.CertificatePDFUrl !== 'undefined' && userObj.UserCertificate.CertificatePDFUrl !== null && userObj.UserCertificate.CertificatePDFUrl !== 'null' && userObj.UserCertificate.CertificatePDFUrl !== '') || (userObj.UserCertificate.CertificateImageUrl !== undefined && userObj.UserCertificate.CertificateImageUrl !== 'undefined' && userObj.UserCertificate.CertificateImageUrl !== null && userObj.UserCertificate.CertificateImageUrl !== 'null' && userObj.UserCertificate.CertificateImageUrl !== '')) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    checkIfCertificateGeneratedForAll: function () {
      var nonCertificateGenerateHolderName = []
      forEach(this.userIdListToProccess, (userId) => {
        const selectedUserObj = find(this.UserObjList, (obj) => {
          return obj.UserId === userId
        })
        if (!this.isUserCertificatePresent(selectedUserObj)) {
          nonCertificateGenerateHolderName.push(selectedUserObj.FirstName + ' ' + selectedUserObj.LastName)
        }
      })
      var objToReturn = {
        HasCertificateGeneratedForAll: nonCertificateGenerateHolderName.length === 0,
        NonCertificateGenerateHolders: nonCertificateGenerateHolderName.join()
      }
      return objToReturn
    },
    changeViewCertificatetSate: function () {
      var storeObj = this.$store
      var _this = this
      // _this.showSpinner = true
      _this.$store.state.isLoading = true
      participantService
        .updateUserViewCertificate(
          storeObj.state.access_token,
          this.selectedCohortObj.CohortId,
          this.isAllowed,
          this.userIdListToProccess
        )
        .then(responseObj => {
          if (responseObj.status >= 200 && responseObj.status < 300) {
            // AK: Hide Spinner after successful response
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            // AK: Refresh Participant List (Un-enrolllParticipantFilterBar file)
            _this.getParticipantListUsingCohort(true)
          } else {
            this.showAlertDialog = true
            this.errorMsg = 'Oops! Something went wrong. Please try again.'
            // AK: Hide Spinner if error occured
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
          }
        }, errorObj => {
          // AK: Hide Spinner if error occured
          // _this.showSpinner = false
          _this.$store.state.isLoading = false
          this.showAlertDialog = true
          if (errorObj.response === undefined) {
            this.errorMsg = constants.No_Internet_Connection_Msg
          } else {
            this.errorMsg = errorObj.response.statusText
          }
        })
    },
    changeToolkitState: function () {
      var storeObj = this.$store
      var _this = this
      // _this.showSpinner = true
      _this.$store.state.isLoading = true
      participantService
        .allowToolkitForAll(
          storeObj.state.access_token,
          this.selectedCohortObj.CohortId,
          this.userIdListToProccess,
          this.isAllowed
        )
        .then(responseObj => {
          if (responseObj.status >= 200 && responseObj.status < 300) {
            // AK: Hide Spinner after successful response
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            // AK: Refresh Participant List (Un-enrolllParticipantFilterBar file)
            _this.getParticipantListUsingCohort(true)
          } else {
            this.showAlertDialog = true
            this.errorMsg = 'Oops! Something went wrong. Please try again.'
            // AK: Hide Spinner if error occured
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
          }
        }, errorObj => {
          // AK: Hide Spinner if error occured
          // _this.showSpinner = false
          _this.$store.state.isLoading = false
          this.showAlertDialog = true
          if (errorObj.response === undefined) {
            this.errorMsg = constants.No_Internet_Connection_Msg
          } else {
            this.errorMsg = errorObj.response.statusText
          }
        })
    },
    changeCourseState: function () {
      var storeObj = this.$store
      var _this = this
      // _this.showSpinner = true
      _this.$store.state.isLoading = true
      participantService
        .allowCourseForAll(
          storeObj.state.access_token,
          this.selectedCohortObj.CohortId,
          this.userIdListToProccess,
          this.isAllowed
        )
        .then(responseObj => {
          if (responseObj.status >= 200 && responseObj.status < 300) {
            // AK: Hide Spinner after successful response
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            // AK: Refresh Participant List (Un-enrolllParticipantFilterBar file)
            _this.getParticipantListUsingCohort(true)
          } else {
            this.showAlertDialog = true
            this.errorMsg = 'Oops! Something went wrong. Please try again.'
            // AK: Hide Spinner if error occured
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
          }
        }, errorObj => {
          // AK: Hide Spinner if error occured
          // _this.showSpinner = false
          _this.$store.state.isLoading = false
          this.showAlertDialog = true
          if (errorObj.response === undefined) {
            this.errorMsg = constants.No_Internet_Connection_Msg
          } else {
            this.errorMsg = errorObj.response.statusText
          }
        })
    },
    updateShowConfirmationAlertFlag (value) {
      // AK: Used when user pressed close button of Confirmation overlay
      this.showConfirmationBox = value
    },
    performOperation (value) {
      // AK: Hide Confirmation Overlay
      this.showConfirmationBox = false
      if (value) {
        switch (this.selectedOperationType) {
          case 'participant':
            if (this.isAllowed) {
              this.enrollMultipleParticipant()
            } else {
              this.unEnrollMultipleParticipant()
            }
            break
          case 'toolkit':
            this.changeToolkitState()
            break
          case 'course':
            this.changeCourseState()
            break
          case 'certificate':
            this.changeViewCertificatetSate()
            break
          case 'generate_certificate_for_selected':
            this.showBatchGenerationCertificateRespOverlay = false
            this.regeneratesUserCertificateIdsResp = []
            this.regenerateUserCertificateIds = []
            this.totalBatchCertificateGenerationCount = 0
            var userArrToProcess = []
            forEach(this.userIdListToProccess, (userId) => {
              const selectedUserObj = find(this.UserObjList, (obj) => {
                return obj.UserId === userId
              })
              userArrToProcess.push(selectedUserObj)
            })
            this.regenerateUserCertificateIds = userArrToProcess
            this.totalBatchCertificateGenerationCount = this.regenerateUserCertificateIds.length
            this.performRegenerateCertificateOperation(true)
            break
        }
      }
    },
    performRegenerateCertificateOperation: function (showSpinner = false) {
      if (this.regenerateUserCertificateIds.length > 0) {
        this.generateUserCertificate(this.regenerateUserCertificateIds[0].UserId, this.regenerateUserCertificateIds[0].FirstName + ' ' + this.regenerateUserCertificateIds[0].LastName, showSpinner)
      } else {
        this.getParticipantListUsingCohort(false)
        console.log('Proccessed Successfully!')
      }
    },
    removeProccessedUserIdFromList: function (userId, showSpinner) {
      this.regenerateUserCertificateIds = filter(this.regenerateUserCertificateIds, (obj) => {
        return obj.UserId !== userId
      })
      this.performRegenerateCertificateOperation(showSpinner)
    },
    logCurrentProccessedRecord: function (fullName, respCode, msgToShow) {
      var objToPush = {
        Name: fullName,
        StatusCode: respCode,
        Description: msgToShow
      }
      this.regeneratesUserCertificateIdsResp.push(objToPush)
      this.showBatchGenerationCertificateRespOverlay = true
    },
    generateUserCertificate: function (userId, fullName, showSpinner) {
      var storeObj = this.$store
      if (showSpinner) {
        this.$store.state.isLoading = true
      }
      participantService
        .generateUserCertificateAtGroupCourse(
          storeObj.state.access_token,
          userId,
          this.getSelectedGroupCourseObj.GroupCourseMasterId,
          this.getSelectedCohortObj.CohortId
        )
        .then(responseObj => {
          if (responseObj.status >= 200 && responseObj.status < 300) {
            // AK: Hide Spinner after successful response
            this.$store.state.isLoading = false
            this.logCurrentProccessedRecord(fullName, responseObj.status, 'Certificate generated successfully.')
            this.removeProccessedUserIdFromList(userId, false)
          } else {
            this.showAlertDialog = false
            this.errorMsg = 'Oops! Something went wrong. Please try again.'
            // AK: Hide Spinner if error occured
            this.$store.state.isLoading = false
            this.logCurrentProccessedRecord(fullName, responseObj.status, this.errorMsg)
            this.removeProccessedUserIdFromList(userId, false)
          }
        }, errorObj => {
          // AK: Hide Spinner if error occured
          this.$store.state.isLoading = false
          this.showAlertDialog = false
          if (errorObj.response === undefined) {
            this.errorMsg = constants.No_Internet_Connection_Msg
          } else {
            this.errorMsg = errorObj.response.statusText
          }
          // console.log('errorObj ::: ' + JSON.stringify(errorObj))
          this.logCurrentProccessedRecord(fullName, errorObj.response.status, this.errorMsg)
          this.removeProccessedUserIdFromList(userId, false)
        })
    },
    unEnrollMultipleParticipant: function () {
      var storeObj = this.$store
      this.$store.state.isLoading = true
      participantService
        .unEnrollMultipleParticipant(
          storeObj.state.access_token,
          this.userIdListToProccess,
          this.selectedCohortObj.CohortId
        )
        .then(responseObj => {
          if (responseObj.status >= 200 && responseObj.status < 300) {
            this.$store.state.isLoading = false
            this.getParticipantListUsingCohort(true)
          } else {
            this.showAlertDialog = true
            this.errorMsg = 'Oops! Something went wrong. Please try again.'
            // AK: Hide Spinner if error occured
            this.$store.state.isLoading = false
          }
        }, errorObj => {
          // AK: Hide Spinner if error occured
          this.$store.state.isLoading = false
          this.showAlertDialog = true
          if (errorObj.response === undefined) {
            this.errorMsg = constants.No_Internet_Connection_Msg
          } else {
            this.errorMsg = errorObj.response.statusText
          }
        })
    },
    enrollMultipleParticipant: function () {
      var storeObj = this.$store
      this.$store.state.isLoading = true
      participantService
        .enrollMultipleParticipant(
          storeObj.state.access_token,
          this.userIdListToProccess,
          this.selectedCohortObj.CohortId
        )
        .then(responseObj => {
          if (responseObj.status >= 200 && responseObj.status < 300) {
            this.$store.state.isLoading = false
            this.getParticipantListUsingCohort(true)
          } else {
            this.showAlertDialog = true
            this.errorMsg = 'Oops! Something went wrong. Please try again.'
            // AK: Hide Spinner if error occured
            this.$store.state.isLoading = false
          }
        }, errorObj => {
          // AK: Hide Spinner if error occured
          this.$store.state.isLoading = false
          this.showAlertDialog = true
          if (errorObj.response === undefined) {
            this.errorMsg = constants.No_Internet_Connection_Msg
          } else {
            this.errorMsg = errorObj.response.statusText
          }
        })
    }
  },
  components: {
    'proccessed-certificate-response': ProccessedCertificateResponse,
    'un-enroll-participant-list': UnEnrollParticipantList,
    'alert-box': AlertBox,
    'confirmation-alert': ConfirmationOverlay,
    'loader': Loader
  },
  computed: {
    getGroupCourseList: {
      get: function () {
        return this.$store.state.groupCourseList
      }
    },
    getAssociatedCohorts: {
      get: function () {
        return this.associatedCohortList
      }
    },
    getSelectedCohortObj: {
      get: function () {
        return this.selectedCohortObj
      }
    },
    getSelectedGroupCourseObj: {
      get: function () {
        return this.selectedGroupObj
      }
    },
    getAllowToolkitForAll: {
      get: function () {
        return this.$store.state.allowToolkitForAll
      }
    },
    getDisallowCourseForAll: {
      get: function () {
        return this.$store.state.disallowCourseForAll
      }
    },
    getAllowCertificateForAll: {
      get: function () {
        return this.$store.state.allowCertificateForAll
      }
    }
  },
  watch: {
    selectedGroupObj: function () {
      // AK: Reset Selected Cohort Obj to -1 again
      this.selectedCohortObj = -1
      this.showUnEnrollParticipantList = false
      this.getAssociatedCohortList()
    },
    resetFilter: function () {
      this.selectedGroupObj = -1
      this.selectedCohortObj = -1
      this.showUnEnrollParticipantList = false
      this.associatedCohortList = []
      this.UserObjList = []
      this.sortOrder = 'asc'
      this.sortBy = 'UserProgress'
    }
  },
  name: 'ToolkitAndEnrollmentsFilterBar'
}
</script>

<style scoped>
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.text-align-right {
  text-align: right;
}
.padding-left-right-0Px {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.padding-left-right-1Point5Px {
  padding-left: 1.5px;
  padding-right: 1.5px;
}
.padding-left-0px {
  padding-left: 0px !important;
}
.btn {
  white-space: normal !important;
  word-wrap: break-word;
}
.background-gray {
  background-color: aqua;
}
.overflow-y-hidden {
  overflow-y: hidden !important;
}
.overflow-hidden {
  overflow: hidden;
}
.save-button-width {
  width: 60% !important;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.white-BG {
  background-color: #ffffff;
}
.MainDiv {
  overflow-y: hidden !important;
}
.margin-Top-2Perc {
  margin-top: 2%;
}

.align-center {
  margin: 0 auto !important;
}
.left-border {
  border-left: 1px solid #aaa;
}
.custom-btn {
  padding: 5px 12px !important;
}
.black-border {
  border: 1px solid black;
}
.grey-border {
  border: 1px solid #aaa;
}
.center-block {
  float: none;
  margin-left: auto;
  margin-right: auto;
}
.cursor-pointer {
  cursor: pointer;
}
.text-align-left {
  text-align: left !important;
}
.font-size-20px {
  font-size: 20px;
}
.font-weight-bold {
  font-weight: bold;
}
.width {
  width: 5%;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.margin-top-1Perc {
  margin-top: 1%;
}
.margin-top-3Perc {
  margin-top: 3%;
}
.float-right {
  float: right;
}
.unenroll-existing-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.black-font-color {
  color: #000;
}
.width-12Point4Perc{
  width:12.4%;
}
.padding-left-1Point5Perc{
  padding-left:1.5%;
}
</style>


// WEBPACK FOOTER //
// src/components/ToolkitAndEnrollmentsFilterBar.vue